import { CheckoutListUrlSortField } from "@dashboard/checkouts/urls";
import { CheckoutSortField } from "@dashboard/graphql";
import { createGetSortQueryVariables } from "@dashboard/utils/sort";

export function getSortQueryField(sort: CheckoutListUrlSortField): CheckoutSortField {
  switch (sort) {
    case CheckoutListUrlSortField.date:
      return CheckoutSortField.CREATION_DATE;
    case CheckoutListUrlSortField.customer:
      return CheckoutSortField.CUSTOMER;
    case CheckoutListUrlSortField.status:
      return CheckoutSortField.PAYMENT;
    default:
      throw new Error("Invalid sort field");
  }
}

export const getSortQueryVariables = createGetSortQueryVariables(getSortQueryField);
